import { HeadBannerResponse } from './headBanner.types'
import apiFetchClient from '../apiFetchClient'

const getHeadBanner = async (): Promise<HeadBannerResponse> => {
    const result = await apiFetchClient<HeadBannerResponse>(
        '/head-banner/',
        {
            method: 'GET',
            skipBreadcrumb: true,
        }
    )
    return result
}

export default getHeadBanner
